import React, { useState } from 'react';
import { Row, Col, Button, Container, FormInput } from 'shards-react';
import AsyncSelect from 'react-select/async';
import PageTitle from '../../../components/PageTitle';
import Errors from '../../../components/Errors';
import { ReadinessReport } from '../../../components/common/ReadinessReport';
import { debouncedFetchAccounts } from '../../../utils/accounts';
import CredentialMigrationService from '../../../services/CredentialMigrationService';

export function CheckReadiness() {
  const [credentialId, setCredentialId] = useState('');
  const [toAccount, setToAccount] = useState(null);
  const [readiness, setReadiness] = useState(null);
  const [errors, setErrors] = useState([]);

  const onCheck = async () => {
    setErrors([]);
    setReadiness(null);
    const credentialMigrationService = CredentialMigrationService();
    credentialMigrationService
      .readiness(credentialId, toAccount ? toAccount.value : null)
      .then((data) => {
        if (!data) {
          setErrors(['No se encontró la credencial o la cuenta destino.']);
          return;
        }
        setReadiness(data);
      })
      .catch(() => setErrors(['No se pudo obtener el diagnóstico. Verificá el credentialId.']));
  };

  return (
    <Container className="main-content-container px-4" fluid>
      <Row className="page-header py-4" noGutters>
        <PageTitle className="text-sm-left" sm="4" subtitle="" title="Verificar prerequisitos" />
      </Row>
      <Errors errors={errors} />
      <Row>
        <Col className="form-group" lg="4" sm="12" xs="12">
          <label htmlFor="credentialId">Credential ID</label>
          <FormInput
            id="credentialId"
            onChange={(e) => setCredentialId(e.target.value)}
            placeholder="Credential ID"
            value={credentialId}
          />
        </Col>
        <Col className="form-group" lg="4" sm="12" xs="12">
          <label htmlFor="toAccountId">Cuenta destino (opcional)</label>
          <AsyncSelect
            cacheOptions={true}
            id="toAccountId"
            isClearable
            loadOptions={debouncedFetchAccounts}
            onChange={(option) => setToAccount(option)}
            placeholder="Busca la cuenta destino por nombre"
            value={toAccount}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button disabled={credentialId === ''} onClick={onCheck}>
            Verificar
          </Button>
        </Col>
      </Row>
      {readiness && (
        <Row className="MarginTop20">
          <Col>
            <ReadinessReport readiness={readiness} />
          </Col>
        </Row>
      )}
    </Container>
  );
}
